export const companyModules = (state) => state.company.modules;
export const companyModulesLoading = (state) => state.company.loading;
export const postSupportTicketLoadingSelector = (state) => state.company.postSupportTicketLoading;
export const isCreateTicketSelector = (state) => state.company.isCreateTicket;
export const isLoadingCompanySelector = (state) => state.company.isLoadingCompany;
export const companyInfoSelector = (state) => state.company.companyInfo;
